import { useEffect } from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AOS from 'aos';
import { Helmet } from 'react-helmet';
import 'aos/dist/aos.css';
import "../css/Quotes.css";

export const Quotes = () => {
  useEffect(() => {
    AOS.init({
      duration: 800, // Animation duration in milliseconds
      once: false,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Quotes | Lone Wolf Writes</title>
        <meta name="description" content="Quotes Lone Wolf Writes" />
        <link rel="canonical" href="https://www.mysite.com/seo/backlink-strategies" />
      </Helmet>
      <main>
      <div className='container mt-4'>
        <h1 style={{ textAlign: "center", fontSize: "largest", marginBottom: "40px" }}>Quotes by Lone Wolf Writes</h1>
        <Tabs
          defaultActiveKey="profile"
          id="fill-tab-example"
          className="mb-3"
          fill
        >
          <Tab eventKey="profile" title="Love">
            <div className="row">
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/Believe in yourself.jpg" alt=" Believe in yourself | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/You are enough.jpg" alt=" You are enough | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/Value of your words.jpg" alt=" Value of your words | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/My anger2.jpg" alt=" My anger2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/my inspiration.jpg" alt=" my inspiration | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/heart of stone.jpg" alt=" heart of stone | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/kalpsia2.jpg" alt=" kalpsia2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Kalopsia.jpg" alt=" Kalopsia | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/My anger2.jpg" alt=" My anger2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="home" title="Broken Heart">
            <div className="row">
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/Believe in yourself.jpg" alt=" Believe in yourself | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/You are enough.jpg" alt=" You are enough | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/Value of your words.jpg" alt=" Value of your words | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/My anger2.jpg" alt=" My anger2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/my inspiration.jpg" alt=" my inspiration | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/heart of stone.jpg" alt=" heart of stone | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/kalpsia2.jpg" alt=" kalpsia2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Kalopsia.jpg" alt=" Kalopsia | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/My anger2.jpg" alt=" My anger2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
          </Tab>
          <Tab eventKey="longer-tab" title="Attitude">
            <div className="row">
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/Believe in yourself.jpg" alt=" Believe in yourself | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/You are enough.jpg" alt=" You are enough | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up">
                <div className="quotes">
                  <img src="/media/Quotes/Value of your words.jpg" alt=" Value of your words | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/My anger2.jpg" alt=" My anger2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/my inspiration.jpg" alt=" my inspiration | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/heart of stone.jpg" alt=" heart of stone | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/kalpsia2.jpg" alt=" kalpsia2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Kalopsia.jpg" alt=" Kalopsia | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/My anger2.jpg" alt=" My anger2 | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
              <div className="col-md-4" data-aos="fade-up"><div className="quotes">
                <img src="/media/Quotes/Lost in your thoughts.jpg" alt=" Lost in your thoughts | Lone Wolf writes " style={{ width: '97%', height: '87%', marginTop: '40px' }} /></div>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
      </main>
    </>
  )
}